import { render, staticRenderFns } from "./Saturation.vue?vue&type=template&id=10479c36"
import script from "./Saturation.vue?vue&type=script&lang=ts"
export * from "./Saturation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports